import '../CsvJsonInfoPages.scss';


function PackContents() {

    const data = [
        { field: 1, description: 'Period Code (Int) — Links to NVDPackContents' },
        { field: 2, description: 'Pack Code (Int) — Links to an Option Code in NVDDictionaryOption' },
        { field: 3, description: 'Date Effective From (Date)' },
        { field: 4, description: 'Date Effective To (Date)' },
    ];


    const data2 = [
        { field: 1, description: 'Period Code (Int)' },
        { field: 2, description: 'Option Code (Int)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Pack Contents</h1>
            <p>This consists of two files - NVDPackPeriods and NVDPackContents. Together, they list the items which are contained in a pack.<br /><br />
                <b>Pack Periods</b><br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDPackPeriods.txt<br />
                LIGHTS_yyyy-mm-dd_NVDPackPeriods.txt<br />
                HEAVIES_yyyy-mm-dd_NVDPackPeriods.txt<br />
                BIKES_yyyy-mm-dd_NVDPackPeriods.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>
                <b>Pack Contents</b><br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br/><br/>

                CAR_yyyy-mm-dd_NVDPackContents.txt<br/>
                LIGHTS_yyyy-mm-dd_NVDPackContents.txt<br/>
                HEAVIES_yyyy-mm-dd_NVDPackContents.txt<br/>
                BIKES_yyyy-mm-dd_NVDPackContents.txt<br/><br/>

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default PackContents;
